import * as React from 'react';

import { DynamicComponents } from 'app/components/DynamicComponents/Loadable';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function Step2({
  vehicleFilterFieldMapper,
  handleDynamicComponentChange,
  handleClickGetInventory,
  inventoryButtonRef,
}) {
  return (
    <Stack spacing={3} direction="row" useFlexGap flexWrap="wrap">
      <Typography
        variant="h5"
        gutterBottom
        component="div"
        sx={{ marginBottom: '10px', width: '100%' }}
      >
        Filter & Select Inventory
      </Typography>

      {vehicleFilterFieldMapper.map((item, index) => (
        <DynamicComponents
          key={String(index)}
          field={item}
          handleDynamicComponentChange={handleDynamicComponentChange}
        />
      ))}
      <Button
        ref={inventoryButtonRef}
        variant="contained"
        sx={{
          color: 'white',
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '80px',
        }}
        onClick={handleClickGetInventory}
      >
        Get Inventory
      </Button>
    </Stack>
  );
}
